import { startAuthFlow } from '../api/UnifiedAccountApi';
import { AuthenticateError } from '../../shared/types/authErrors';
import { createBuildAuthPayload, createAuthorizeUrlFetcher, createReconnectAuthorizeUrlFetcher, createFinishNewAccountHandler, createFinishReconnectHandler, createFinishMigrationReconnectHandler, resolveOAuthScopeSet } from './authFlowConfigHelpers';
async function startAndValidateAuthFlow(portalId, appId, appName) {
  const response = await startAuthFlow(portalId, {
    appId,
    appName
  });
  if (response['@result'] !== 'OK') {
    var _response$upstreamErr;
    throw new AuthenticateError(response.localizedErrorMessage, (_response$upstreamErr = response.upstreamError) === null || _response$upstreamErr === void 0 ? void 0 : _response$upstreamErr.upstreamErrorMessageInterpretation);
  }
  return response;
}
export function createAuthConfigFetchers(config) {
  const {
    portalId,
    appId,
    appName,
    appIcon = '',
    oAuthScope,
    oAuthScopes,
    mcpParams
  } = config;
  const resolvedOAuthScopeSet = resolveOAuthScopeSet(oAuthScope, oAuthScopes);
  return {
    forNewAccount: async () => {
      const {
        authenticationFlow,
        sessionId,
        appName: resolvedAppName
      } = await startAndValidateAuthFlow(portalId, appId, appName);
      return {
        appName: resolvedAppName,
        appIcon,
        appId,
        oAuthScopeSet: resolvedOAuthScopeSet,
        mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined,
        authFlow: Object.assign({}, authenticationFlow, {
          sessionId
        }),
        buildAuthPayload: createBuildAuthPayload(appId),
        makeAuthorizeUrlDescriptor: createAuthorizeUrlFetcher({
          portalId,
          appId,
          sessionId
        }),
        finishAuthFlow: createFinishNewAccountHandler({
          portalId,
          appId
        })
      };
    },
    forReconnect: async accountId => {
      const {
        authenticationFlow,
        sessionId,
        appName: resolvedAppName
      } = await startAndValidateAuthFlow(portalId, appId, appName);
      return {
        appName: resolvedAppName,
        appIcon,
        oAuthScopeSet: resolvedOAuthScopeSet,
        mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined,
        authFlow: Object.assign({}, authenticationFlow, {
          sessionId
        }),
        buildAuthPayload: createBuildAuthPayload(appId),
        makeAuthorizeUrlDescriptor: createReconnectAuthorizeUrlFetcher({
          portalId,
          accountId,
          sessionId
        }),
        finishAuthFlow: createFinishReconnectHandler({
          portalId,
          accountId
        })
      };
    },
    forMigrationReconnect: async oAuthorAccountId => {
      const {
        authenticationFlow,
        sessionId,
        appName: resolvedAppName
      } = await startAndValidateAuthFlow(portalId, appId, appName);
      return {
        appName: resolvedAppName,
        appIcon,
        oAuthScopeSet: resolvedOAuthScopeSet,
        mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined,
        authFlow: Object.assign({}, authenticationFlow, {
          sessionId
        }),
        buildAuthPayload: createBuildAuthPayload(appId),
        makeAuthorizeUrlDescriptor: createAuthorizeUrlFetcher({
          portalId,
          appId,
          sessionId
        }),
        finishAuthFlow: createFinishMigrationReconnectHandler({
          portalId,
          appId,
          oAuthorAccountId
        })
      };
    }
  };
}